// @ts-ignore

import { Link } from "react-router-dom";
// @ts-ignore
import dextoolsLogo from "../assets/images/dextools.png";
import { getDextoolsChartLink } from "./utils/getDextoolsChartLink";

type Props = {
  telegram: string;
  twitter: string;
  website: string;
  chart: string;
  chain: string;
};

const ContestSocials: React.FC<Props> = ({
  telegram,
  twitter,
  website,
  chart,
  chain
}) => {
  return (
    <>
      {telegram && (
        <Link to={telegram} target="_blank" style={{ marginTop: "8px" }}>
          <img
            width="30"
            height="30"
            src="https://img.icons8.com/color/230/telegram-app--v1.png"
            alt="telegram-app--v1"
            style={{ marginRight: "8px" }}
          />
        </Link>
      )}
      {twitter && (
        <Link to={twitter} target="_blank" style={{ marginTop: "8px" }}>
          <img
            width="30"
            height="30"
            src="https://img.icons8.com/color/230/twitterx--v1.png"
            alt="twitterx--v1"
            style={{ marginRight: "8px" }}
          />
        </Link>
      )}
      {website && (
        <Link
          to={website}
          target="_blank"
          style={{ marginTop: "8px", marginRight: 6 }}
        >
          <img
            width="28"
            height="28"
            src="https://img.icons8.com/dusk/64/domain.png"
            alt="domain"
          />
        </Link>
      )}
      {chart && (
        <Link
          to={getDextoolsChartLink(chart, chain)}
          target="_blank"
          style={{ marginTop: "8px" }}
        >
          <img
            width="30"
            height="30"
            src={dextoolsLogo}
            alt="dextools-chart"
            style={{ marginRight: "8px" }}
          />
        </Link>
      )}
    </>
  );
};

export default ContestSocials;
